<template>
  <CustomModal @close="$emit('close')">
    <template v-slot:header>
      <div class="text-xl font-bold text-text leading-tight mb-4 pt-0">
        <slot name="title"></slot>
      </div>
    </template>
    <template v-slot:body>
      <div class="settings-edit-modal">
        <slot name="form"></slot>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";

export default {
  name: "SpaceSettingsEditModalTemplate",
  props: {
    title: {
      type: String
    }
  },
  components: {CustomModal}
}
</script>

<style scoped lang="scss">
.settings-edit-modal {
  @apply -mx-8 -mb-12  mt-0 p-10 bg-white-top-gradient rounded;
  width: 600px;
  @media(min-width: 1230px) {
    @apply -mx-12;
    width: 820px;
  }
}
</style>